// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Videospage_main__T42xj {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
}

.Videospage_section__ImMZE {
    text-align: center;
}

.Videospage_section__ImMZE h1 {
    color: #406343;
    font-size: 35px;
    margin-bottom: 10px;
}

.Videospage_section__ImMZE span{
    font-weight: bold;
    font-size: 18px;
}

.Videospage_main__T42xj p {
    color: #7f7f7f;
    font-weight: bold;
    line-height: 1.8;
    margin-bottom: 10px;
}

.Videospage_container__QiYeb {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto; 
    padding: 0 20px; 
}

.Videospage_bodyContent__qGqcN {
    display: flex;
    gap: 50px;
    width: 100%;
}

@media (min-width: 576px) {
    .Videospage_container__QiYeb, .Videospage_container-sm__8gXgm {
        max-width: 540px;
        margin: 0 auto;
    }
}

@media (min-width: 768px) {
    .Videospage_container__QiYeb, .Videospage_container-md__4zxVk {
        max-width: 720px;
        margin: 0 auto;
    }
}

@media (min-width: 992px) {
    .Videospage_container__QiYeb, .Videospage_container-lg__mKHL3 {
        max-width: 960px;
        margin: 0 auto;
    }
}

@media (min-width: 1200px) {
    .Videospage_container__QiYeb, .Videospage_container-xl__uetQ4 {
        max-width: 1100px;
        margin: 0 auto;
    }
}

@media (min-width: 1400px) {
    .Videospage_container__QiYeb, .Videospage_container-xxl__QAMiZ {
        max-width: 1220px;
        margin: 0 auto;
    }
}

@media (min-width: 1600px) {
    .Videospage_container__QiYeb, .Videospage_container-xxxl__ZNSOU {
        max-width: 1400px;
        margin: 0 auto;
    }
}

@media (min-width: 1920px) {
    .Videospage_container__QiYeb, .Videospage_container-4k__zJ0de {
        max-width: 1550px;
        margin: 0 auto;
    }
}

.Videospage_speeches__eOQ6t.Videospage_section-before-footer__OW8SJ {
    margin-bottom: 180px !important;
}

@media (max-width: 768px) {
    .Videospage_speeches__eOQ6t.Videospage_section-before-footer__OW8SJ {
        margin-bottom: 220px !important;
    }
    
    .Videospage_container__QiYeb {
        padding: 0 15px;
    }
    
    .Videospage_bodyContent__qGqcN {
        flex-direction: column;
        gap: 20px;
    }
}

@media (max-width: 480px) {
    .Videospage_speeches__eOQ6t.Videospage_section-before-footer__OW8SJ {
        margin-bottom: 280px !important;
    }
    
    .Videospage_container__QiYeb {
        padding: 0 10px;
    }
    
    .Videospage_bodyContent__qGqcN {
        gap: 15px;
    }
}






/* Medium devices */
@media (min-width: 768px) {
  .Videospage_container__QiYeb, .Videospage_container-md__4zxVk {
    max-width: 720px;
  }
}

/* Large devices  */
@media (min-width: 992px) {
  .Videospage_container__QiYeb, .Videospage_container-lg__mKHL3 {
    max-width: 960px;
  }
}

/* Extra large devices  */
@media (min-width: 1200px) {
  .Videospage_container__QiYeb, .Videospage_container-xl__uetQ4 {
    max-width: 1140px;
  }
}

/* XX-Large devices */
@media (min-width: 1400px) {
  .Videospage_container__QiYeb, .Videospage_container-xxl__QAMiZ {
    max-width: 1320px;
  }
}

/* XXX-Large devices */
@media (min-width: 1600px) {
  .Videospage_container__QiYeb, .Videospage_container-xxxl__ZNSOU {
    max-width: 1500px;
  }
}

/* 4K and larger displays */
@media (min-width: 1920px) {
  .Videospage_container__QiYeb, .Videospage_container-4k__zJ0de {
    max-width: 1800px;
  }
}









/* Medium devices  */
@media (min-width: 768px) {
  .Videospage_container__QiYeb, .Videospage_container-md__4zxVk {
    max-width: 720px;
  }
}

/* Large devices */
@media (min-width: 992px) {
  .Videospage_container__QiYeb, .Videospage_container-lg__mKHL3 {
    max-width: 960px;
  }
}

/* Extra large devices */
@media (min-width: 1200px) {
  .Videospage_container__QiYeb, .Videospage_container-xl__uetQ4 {
    max-width: 1140px;
  }
}

/* XX-Large devices */
@media (min-width: 1400px) {
  .Videospage_container__QiYeb, .Videospage_container-xxl__QAMiZ {
    max-width: 1320px;
  }
}

/* XXX-Large devices*/
@media (min-width: 1600px) {
  .Videospage_container__QiYeb, .Videospage_container-xxxl__ZNSOU {
    max-width: 1500px;
  }
}

/* 4K and larger displays */
@media (min-width: 1920px) {
  .Videospage_container__QiYeb, .Videospage_container-4k__zJ0de {
    max-width: 1800px;
  }
}`, "",{"version":3,"sources":["webpack://./src/website/Videos/Videospage.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;AACJ;;;;;;;AAOA,mBAAmB;AACnB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;AACF;;;;;;;;;;AAUA,oBAAoB;AACpB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".main {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.section {\r\n    text-align: center;\r\n}\r\n\r\n.section h1 {\r\n    color: #406343;\r\n    font-size: 35px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.section span{\r\n    font-weight: bold;\r\n    font-size: 18px;\r\n}\r\n\r\n.main p {\r\n    color: #7f7f7f;\r\n    font-weight: bold;\r\n    line-height: 1.8;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.container {\r\n    width: 100%;\r\n    max-width: 1200px;\r\n    margin: 0 auto; \r\n    padding: 0 20px; \r\n}\r\n\r\n.bodyContent {\r\n    display: flex;\r\n    gap: 50px;\r\n    width: 100%;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n    .container, .container-sm {\r\n        max-width: 540px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .container, .container-md {\r\n        max-width: 720px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .container, .container-lg {\r\n        max-width: 960px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .container, .container-xl {\r\n        max-width: 1100px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n    .container, .container-xxl {\r\n        max-width: 1220px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n    .container, .container-xxxl {\r\n        max-width: 1400px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n    .container, .container-4k {\r\n        max-width: 1550px;\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.speeches.section-before-footer {\r\n    margin-bottom: 180px !important;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .speeches.section-before-footer {\r\n        margin-bottom: 220px !important;\r\n    }\r\n    \r\n    .container {\r\n        padding: 0 15px;\r\n    }\r\n    \r\n    .bodyContent {\r\n        flex-direction: column;\r\n        gap: 20px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .speeches.section-before-footer {\r\n        margin-bottom: 280px !important;\r\n    }\r\n    \r\n    .container {\r\n        padding: 0 10px;\r\n    }\r\n    \r\n    .bodyContent {\r\n        gap: 15px;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Medium devices */\r\n@media (min-width: 768px) {\r\n  .container, .container-md {\r\n    max-width: 720px;\r\n  }\r\n}\r\n\r\n/* Large devices  */\r\n@media (min-width: 992px) {\r\n  .container, .container-lg {\r\n    max-width: 960px;\r\n  }\r\n}\r\n\r\n/* Extra large devices  */\r\n@media (min-width: 1200px) {\r\n  .container, .container-xl {\r\n    max-width: 1140px;\r\n  }\r\n}\r\n\r\n/* XX-Large devices */\r\n@media (min-width: 1400px) {\r\n  .container, .container-xxl {\r\n    max-width: 1320px;\r\n  }\r\n}\r\n\r\n/* XXX-Large devices */\r\n@media (min-width: 1600px) {\r\n  .container, .container-xxxl {\r\n    max-width: 1500px;\r\n  }\r\n}\r\n\r\n/* 4K and larger displays */\r\n@media (min-width: 1920px) {\r\n  .container, .container-4k {\r\n    max-width: 1800px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n/* Medium devices  */\r\n@media (min-width: 768px) {\r\n  .container, .container-md {\r\n    max-width: 720px;\r\n  }\r\n}\r\n\r\n/* Large devices */\r\n@media (min-width: 992px) {\r\n  .container, .container-lg {\r\n    max-width: 960px;\r\n  }\r\n}\r\n\r\n/* Extra large devices */\r\n@media (min-width: 1200px) {\r\n  .container, .container-xl {\r\n    max-width: 1140px;\r\n  }\r\n}\r\n\r\n/* XX-Large devices */\r\n@media (min-width: 1400px) {\r\n  .container, .container-xxl {\r\n    max-width: 1320px;\r\n  }\r\n}\r\n\r\n/* XXX-Large devices*/\r\n@media (min-width: 1600px) {\r\n  .container, .container-xxxl {\r\n    max-width: 1500px;\r\n  }\r\n}\r\n\r\n/* 4K and larger displays */\r\n@media (min-width: 1920px) {\r\n  .container, .container-4k {\r\n    max-width: 1800px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Videospage_main__T42xj`,
	"section": `Videospage_section__ImMZE`,
	"container": `Videospage_container__QiYeb`,
	"bodyContent": `Videospage_bodyContent__qGqcN`,
	"container-sm": `Videospage_container-sm__8gXgm`,
	"container-md": `Videospage_container-md__4zxVk`,
	"container-lg": `Videospage_container-lg__mKHL3`,
	"container-xl": `Videospage_container-xl__uetQ4`,
	"container-xxl": `Videospage_container-xxl__QAMiZ`,
	"container-xxxl": `Videospage_container-xxxl__ZNSOU`,
	"container-4k": `Videospage_container-4k__zJ0de`,
	"speeches": `Videospage_speeches__eOQ6t`,
	"section-before-footer": `Videospage_section-before-footer__OW8SJ`
};
export default ___CSS_LOADER_EXPORT___;
